import { getJWTToken } from '../../utils/auth';
import { authHeaders } from '../../core/impersonation';

const apiUrl = import.meta.env.REACT_APP_BAMBOO_API_URL ?? '';

export type PlanDataSource = 'placeholder' | 'live';

export type StudentPlanData = {
  source: PlanDataSource;
  student: {
    firstName: string | null;
    lastName: string | null;
    grade: string | null;
    homeLanguage: string | null;
    ellStatus: string | null;
    yearsInEl: string | null;
    programModel: string | null;
    elTeacher: string | null;
  };
  school: { name: string | null };
  district: { name: string | null };
};

export class PlanDataFetchError extends Error {
  status: number;

  constructor(message: string, status: number) {
    super(message);
    this.name = 'PlanDataFetchError';
    this.status = status;
  }
}

export async function fetchStudentPlanData(studentId: string): Promise<StudentPlanData> {
  const token = await getJWTToken();
  const response = await fetch(
    `${apiUrl}/students/${encodeURIComponent(studentId)}/plan-data`,
    { headers: authHeaders(token) },
  );
  if (!response.ok) {
    throw new PlanDataFetchError(
      `plan-data fetch failed: ${response.status}`,
      response.status,
    );
  }
  return (await response.json()) as StudentPlanData;
}

export function hasLiveValue(value: string | null | undefined): value is string {
  return typeof value === 'string' && value.length > 0;
}
